export default __webpack_public_path__ + "static/media/bengali.5c66e4a9.svg";